import { createSelector } from 'reselect';
import CarditResditInterchangesColumns from '../../containers/CarditResditInterchangesColumns';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime = state => state
  .reporting.CARDIT_RESDIT_INTERCHANGES.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting.CARDIT_RESDIT_INTERCHANGES.isLoading;

export const getData =
  ReportDefinitions.CARDIT_RESDIT_INTERCHANGES.getDataFunction();

export const getColumns =
  createSelector(getData, CarditResditInterchangesColumns);
